import { useEffect, useMemo, useRef, useState } from "react";
import * as s from "../AlertViewStyled";
import { useLocation } from "react-router-dom";

import { AlertList, AlertType } from "api/interfaces/alertInterface.interface";
import { Option, alertStatusOptions } from "utils/options";
import SelectComponent, {
  SelectVariant,
} from "components/atoms/select/SelectComponent";
import CCTVRED from "assets/icons/cctv_red.svg";
import SYSTEMALERT from "assets/icons/system_alert.svg";

import VideoThumbnail from "components/atoms/image/thumbnail/VideoThumbnail";
import { filteringDiskAlertBoolean } from "utils/AlertUtil";
import { isCheckPermission } from "utils/AccountUtil";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import ProtectedThumbnail from "components/atoms/image/thumbnail/ProtectedThumbnail";

interface Props {
  alertType: AlertType;
  onChangeCurrentAlert: (alertType: AlertType, value?: string) => void;
  currentAlert: AlertList;
  onChangeStatus: (value: string) => void;
}

const AlertTypeItem = (props: Props) => {
  const location = useLocation();
  const isMap = location.pathname.includes("map");
  const selectRef = useRef(null);
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const alertListStyled = s.AlertTypeListStyled;

  const [selectIds, setSelectIds] = useState<string>(
    props.alertType.alertHistoryId
  );

  const onChangeDetailId = (value: string) => {
    setSelectIds(value);
  };

  const onChangeTypeSelect = (value: string) => {
    onChangeDetailId(value);
    props.onChangeCurrentAlert(props.alertType, value);
  };

  const onChangeCurrentAlert = (event: any) => {
    if (!event.target.classList.value.includes("alert-type-select-box")) {
      if (
        props.alertType.type === "Video Loss" ||
        filteringDiskAlertBoolean(props.alertType)
      ) {
        props.onChangeCurrentAlert(props.alertType, selectIds);
      } else {
        props.onChangeCurrentAlert(props.alertType);
      }
    }
  };

  const icon = (type: string) => {
    if (type === "Video Loss") {
      return CCTVRED;
    } else {
      return SYSTEMALERT;
    }
  };

  useEffect(() => {
    if (props.currentAlert.type !== props.alertType.type) return;
    setSelectIds(props.currentAlert.alertHistoryId);
  }, [props.currentAlert]);
  const currentCamera = useMemo(() => {
    if (
      props.alertType.type === "Video Loss" &&
      props.alertType.cameraList !== undefined
    )
      return undefined;
    return (
      props.alertType.cameraList?.find((cam) => cam.value === selectIds) ??
      props.alertType.cameraList?.[0]
    );
  }, [props.alertType.cameraList, props.alertType.type, selectIds]);

  return (
    <alertListStyled.AlertItem
      selected={props.currentAlert.type === props.alertType.type}
      isMap={isMap}
      onClick={onChangeCurrentAlert}
      data-testid="alert-view-components-alert-item-change-current-alert"
    >
      <alertListStyled.TitleWrapper isMap={isMap}>
        <div className="title">
          <div className="alert-type-icon">
            <img src={icon(props.alertType.type)} alt={props.alertType.type} />
          </div>
          <span>{props.alertType.type}</span>
        </div>
        {props.alertType.type === "Video Loss" &&
          props.alertType.cameraList !== undefined && (
            <alertListStyled.VideoLossThumbnail>
              {currentCamera?.covert ? (
                <ProtectedThumbnail />
              ) : (
                <VideoThumbnail
                  videoLoss={true}
                  thumbnailUrl={currentCamera?.thumbnailUrl}
                  isRecorderList={true}
                />
              )}
            </alertListStyled.VideoLossThumbnail>
          )}
      </alertListStyled.TitleWrapper>
      <alertListStyled.SelectWrapper isMap={isMap}>
        {props.alertType.type === "Video Loss" ||
        filteringDiskAlertBoolean(props.alertType) ? (
          <div className="select-box video" ref={selectRef}>
            {props.alertType.type === "Video Loss" &&
              props.alertType.cameraList !== undefined && (
                <SelectComponent
                  mydwVariant={SelectVariant.ALERT}
                  className="alert-type-select-box"
                  options={props.alertType.cameraList}
                  value={selectIds}
                  // value={props.alertType.cameraList.find(function (option) {
                  //   return option.value === selectIds.cameraId;
                  // })}
                  onChange={(value) => onChangeTypeSelect(value as string)}
                  disabled={props.alertType.cameraList.length === 1}
                  showOptionFullText={true}
                  data-testid="alert-view-components-alert-type-select-change-type-select"
                />
              )}

            {filteringDiskAlertBoolean(props.alertType) &&
              props.alertType.storageList !== undefined && (
                <SelectComponent
                  mydwVariant={SelectVariant.ALERT}
                  // defaultValue={props.alertType.storageList[0]}
                  className="alert-type-select-box"
                  options={props.alertType.storageList}
                  value={selectIds}
                  onChange={(value) => onChangeTypeSelect(value as string)}
                  disabled={props.alertType.storageList.length === 1}
                  data-testid="alert-view-components-alert-type-select-change-type-select-2"
                />
              )}
          </div>
        ) : (
          <div></div>
        )}

        {isCheckPermission("manageAlertRules", selectedAccount) && (
          <div className="select-box" ref={selectRef}>
            <SelectComponent
              mydwVariant={SelectVariant.ALERT}
              options={alertStatusOptions}
              onChange={(value) => props.onChangeStatus(value as string)}
              disabled={props.alertType.status === "Closed"}
              value={
                props.alertType.status === "Assigned"
                  ? "Active"
                  : props.alertType.status
              }
              // defaultValue={defaultValue}
              data-testid="alert-view-components-alert-type-select-change-status"
            />
          </div>
        )}
      </alertListStyled.SelectWrapper>
    </alertListStyled.AlertItem>
  );
};

export default AlertTypeItem;
